import { render, staticRenderFns } from "./EsText.vue?vue&type=template&id=2d7a805b"
import script from "./EsText.vue?vue&type=script&lang=js"
export * from "./EsText.vue?vue&type=script&lang=js"
import style0 from "./EsText.vue?vue&type=style&index=0&id=2d7a805b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports